import ApiHelper from '@/utils/api-helper'
import API from '@/constants/api'

/**
 * Opportunity service class containing all methods to retrieve opportunities
 */
class OpportunityService {
  static getOpportunities(limit = 10, page = 1, options = {}) {
    let apiUrl = `${API.URL + API.OPPORTUNITIES}${options.myCompanyOnly ? '/company' : ''}`

    apiUrl += `?pageSize=${limit}&page=${page}&populate=${!!options.populate}&overview=${!!options.overview}`

    if (options.companyFilter) {
      apiUrl += `&company=${options.companyFilter}`
    }

    return ApiHelper.fetch(apiUrl)
  }

  static getOpportunityLocations() {
    return ApiHelper.fetch(`${API.URL + API.OPPORTUNITIES}/locations`)
  }

  static getOpportunityTypes() {
    return ApiHelper.fetch(`${API.URL + API.OPPORTUNITY_TYPES}`)
  }

  static getOpportunity(id) {
    return ApiHelper.fetch(`${API.URL + API.OPPORTUNITIES}/${id}`)
  }

  static applyOpportunity(slug) {
    return ApiHelper.fetch(`${API.URL + API.OPPORTUNITIES}/apply`, {
      method: 'POST',
      body: JSON.stringify({
        opportunity: slug
      })
    })
  }

  static updateOpportunity(opportunity) {
    if (typeof opportunity._id === 'undefined') {
      return this.addOpportunity(opportunity)
    }

    return ApiHelper.fetch(`${API.URL + API.OPPORTUNITIES}/${opportunity['_id']}`, {
      method: 'PUT',
      body: JSON.stringify({
        opportunity
      })
    })
  }

  static async publishOpportunity(id) {
    const { opportunity } = await this.getOpportunity(id)

    opportunity.publishingDate = new Date()

    return this.updateOpportunity(opportunity)
  }

  static async republishOpportunity(id) {
    const { opportunity } = await this.getOpportunity(id),
      today = new Date()

    today.setMonth(today.getMonth() + 2)
    opportunity.endDate = today

    return this.updateOpportunity(opportunity)
  }

  static async endPublicationOpportunity(id) {
    const { opportunity } = await this.getOpportunity(id)

    opportunity.endDate = new Date()

    return this.updateOpportunity(opportunity)
  }

  static addOpportunity(opportunity) {
    return ApiHelper.fetch(`${API.URL + API.OPPORTUNITIES}`, {
      method: 'POST',
      body: JSON.stringify({
        opportunity
      })
    })
  }

  static deleteOpportunity(id) {
    return ApiHelper.fetch(`${API.URL + API.OPPORTUNITIES}/${id}`, {
      method: 'DELETE'
    })
  }
}

export default OpportunityService
